import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation, Trans } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';


const useStyles = makeStyles({
    textAlign: {
        textAlign: "left"
    }
});

export default function FeedbackModal(props) {
    const { open, onClose } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const [feedback, setFeedback] = useState("");
    const [fromOptionalEmail, setFromOptionalEmail] = useState("");

    function sendFeedbackEmail() {
        fetch(process.env.REACT_APP_FEEDBACK_URL_ENDPOINT, {
            mode: 'cors',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                environment: process.env.REACT_APP_ENVIRONMENT,
                feedback: feedback,
                fromOptionalEmail: fromOptionalEmail
            })
        });
        setFeedback("");
        setFromOptionalEmail("");
        onClose();
    }

    const handleFeedbackChange = (event, newValue) => {
        setFeedback(event.target.value);
    };

    const handleFromOptionalEmailChange = (event, newValue) => {
        setFromOptionalEmail(event.target.value);
    };

    return (
        <Dialog open={open}
            onClose={onClose}
            ria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title" className={classes.textAlign}>{t('feedbackSend')}</DialogTitle>
            <DialogContent>
                <DialogContentText className={classes.textAlign}>
                    {t('feedbackMessage')}
                </DialogContentText>
                <TextField
                    margin="normal"
                    variant="outlined"
                    id="feedbackText"
                    label={t('feedback')}
                    type="text"
                    multiline
                    rows={6}
                    fullWidth
                    value={feedback}
                    onChange={handleFeedbackChange}
                />
                <TextField
                    margin="normal"
                    variant="outlined"
                    id="feedbackEmail"
                    label={t('email')}
                    type="email"
                    fullWidth
                    value={fromOptionalEmail}
                    onChange={handleFromOptionalEmailChange}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" size="large">
                    {t('cancelButton').toUpperCase()}
                    </Button>
                <Button onClick={sendFeedbackEmail} color="primary" variant="contained" size="large">
                    {t('sendButton').toUpperCase()}
                </Button>
            </DialogActions>
        </Dialog>
    );
}


FeedbackModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
